const debug: any = {};
(window as any)._debug = debug;

export function debugAdd(addMap: any) {
    Object.assign(debug, addMap);
}

export default debug;